import { useSearchParams } from 'react-router-dom';
import { useListShareRequestsQuery } from 'rtk/org-admin/share-request.slice';

export default function useShareRequestTabs() {
  const [params, setParams] = useSearchParams();
  const activeTab = params.get('tab') === 'received' ? 'received' : 'sent';
  const sent = useListShareRequestsQuery({
    direction: 'SENT',
    connectionsOnly: true,
    status: 'PENDING',
    maxResults: 1
  });
  const received = useListShareRequestsQuery({
    direction: 'RECEIVED',
    connectionsOnly: true,
    status: 'PENDING',
    maxResults: 1
  });
  const selectTab = tab => {
    if (!['sent', 'received'].includes(tab)) return;
    const next = new URLSearchParams(params);
    next.set('tab', tab);
    next.delete('notificationEntity');
    setParams(next);
  };
  return {
    activeTab,
    selectTab,
    targetGuid: params.get('notificationEntity'),
    sentCount: sent.currentData?.TotalRecords,
    receivedCount: received.currentData?.TotalRecords
  };
}
